import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import { AuthService } from 'zr-arch';
import { container } from 'tsyringe';
import {
    Input,
    ExamManage,
    PaymentManage,
    PromptLogin,
    LoginCallBack,
    SilentCallBack,
    Logout,
} from '@/views';

Vue.use(VueRouter);

const publicRoutes = [Input, PromptLogin, LoginCallBack, SilentCallBack, Logout];

const routes: Array<RouteConfig> = [
    {
        path: '/input',
        name: Input,
        component: () => import('@/views/Input.vue'),
    },
    {
        path: '/promptlogin',
        name: PromptLogin,
        component: () => import('@/views/PromptLogin.vue'),
    },
    {
        path: '/logincallback',
        name: LoginCallBack,
        component: () => import('@/views/LoginCallBack.vue'),
    },
    {
        path: '/silentcallback',
        name: SilentCallBack,
        component: () => import('@/views/SilentCallBack.vue'),
    },
    {
        path: '/logout',
        name: Logout,
        component: () => import('@/views/Logout.vue'),
    },
    {
        path: '/manage',
        component: () => import('@/views/layout/MainLayout.vue'),
        children: [
            { path: 'exam', name: ExamManage, component: () => import('@/views/ExamManage.vue') },
            { path: 'payment', name: PaymentManage, component: () => import('@/views/PaymentManage.vue') },
        ],
    },
    {
        path: '/',
        redirect: '/manage/exam',
    },
];

const router = new VueRouter({
    mode: 'history',
    routes,
});

router.beforeEach(async (to, _from, next) => {
    if (publicRoutes.includes(to.name as string)) {
        next();
        return;
    }
    try {
        const authService = container.resolve<AuthService>(AuthService);
        const user = await authService.getUser();
        if (!user) {
            next({ name: PromptLogin });
            return;
        }
        next();
    } catch {
        next({ name: PromptLogin });
    }
});

export default router;
